import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule, MatIconModule, MatInputModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ShowDataInputModule } from '../../../../../../core/components/show-data-input/show-data-input.module';
import { StarsModule } from '../logs/stars/stars.module';
import { FormDetailsModule } from './form-details/form-details.module';
import { TabFormsComponent } from './tab-forms.component';


@NgModule({
  entryComponents: [
    TabFormsComponent
  ],
  declarations: [
    TabFormsComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    ShowDataInputModule,
    StarsModule,
    PipesModule,
    MatFormFieldModule,
    MatInputModule,
    FormDetailsModule,
  ],
  exports: [
    TabFormsComponent
  ]
})
export class TabFormsModule {
}
